import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import classnames from 'classnames';
import { connect } from 'react-redux';
import {
  FormGroup,
  Label,
  UncontrolledTooltip,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetUserSettingValue } from '../../../api/User';

import ErrorBoundary from '../../ErrorBoundary';
import Loading from '../../Loading';

import { userIsSuperAdmin } from '../../../helpers/Auth';
import { addFlashMessage } from '../../../helpers/FlashMessages';
import { getSetting } from '../../../helpers/Settings';

const AdminUserEditAPIAccess = ({ profile }) => {
  const intl = useIntl();

  const [apiKey, setApiKey] = useState(null);
  const [apiKeyLoading, setApiKeyLoading] = useState(true);
  const [apiKeyFull, setApiKeyFull] = useState(false);
  const [apiKeyCopied, setApiKeyCopied] = useState(false);

  useEffect(() => {
    const fetchApiKey = async () => {
      const userApiKey = await APIgetUserSettingValue(profile.uuid, 'public_api_key');
      if (userApiKey?.data?.value) {
        setApiKey(userApiKey.data.value);
      }
      setApiKeyLoading(false);
    };

    if (getSetting('public_api_enabled') && !userIsSuperAdmin()) {
      fetchApiKey();
    }
  }, [profile.uuid]);

  if (!getSetting('public_api_enabled') || userIsSuperAdmin()) {
    return null;
  }

  const handleCopy = () => {
    setApiKeyCopied(true);
    setTimeout(() => {
      setApiKeyCopied(false);
    }, 3000);

    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'Authentication token copied' }),
    });
  };

  const handleShowAuthToken = (e) => {
    e.preventDefault();
    setApiKeyFull(true);
  };

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper api-access-content">
        <h4>
          {intl.formatMessage({ defaultMessage: 'API access' })}
        </h4>
        <FormGroup>
          {apiKeyLoading ? (
            <Loading />
          ) : (
            <>
              <Label for="api-key">
                {intl.formatMessage({ defaultMessage: 'Authentication token' })}
                <CopyToClipboard
                  text={apiKey}
                  options={{
                    format: 'text/plain',
                  }}
                  onCopy={handleCopy}
                >
                  <a href="#copy" onClick={(e) => { e.preventDefault(); }} id="copy-api-key">
                    {apiKeyCopied ? (
                      <i className="far fa-check ml-2" />
                    ) : (
                      <i className="far fa-copy ml-2" />
                    )}
                  </a>
                </CopyToClipboard>
                <UncontrolledTooltip fade={false} target="copy-api-key">
                  {intl.formatMessage({ defaultMessage: 'Copy authentication token' })}
                </UncontrolledTooltip>
              </Label>
              <div id="api-key" className={classnames('authentication-token', { 'show-short': !apiKeyFull })}>
                <code>
                  {apiKey}
                </code>
                <a href="#show" onClick={handleShowAuthToken}>show</a>
              </div>
            </>
          )}
        </FormGroup>
      </div>
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
});

AdminUserEditAPIAccess.propTypes = {
  profile: PropTypes.object.isRequired,
};

export default connect(mapStateToProps)(AdminUserEditAPIAccess);
